import React, { memo } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

import style from './GameLabels.scss';

export const GameLabelsBare: React.FC<Types.IGameLabelsProps> = ({ game, className = '' }) => {
    const translate = useTranslations();
    const { gameLabels } = game;

    if (!gameLabels.length || !gameLabels.some((element) => Boolean(element.name) && element.isVisible)) {
        return null;
    }

    return (
        <ul className={`${style.labelsContainer} ${className} cms-games-grid-game-labels`}>
            {gameLabels.map((label) =>
                Boolean(label.name) && label.isVisible && (
                    <li
                        key={label.name}
                        className={`${style.label} cms-games-grid-game-label-${label.name}`}
                    >
                        {translate(`playtech.mobile.system.gamelabel.${label.name}`, label.name)}
                    </li>
                )
            )}
        </ul>
    );
};

export const GameLabels = memo(GameLabelsBare);
